import { ImagePixelDataGrid } from 'utils/ImagePixelDataGrid';
import HomeParticleJson from 'app/views/home/webgl/particles/config/HomeParticleJson';

//Shape of a dataSet entry. pixelData/rawGrid are attached asynchronously by
//loadPixels() once the source image has been sampled.
export interface PixelDataItem {
	ref: string;
	size: { w: number; h: number };
	position: { x: number; y: number };
	frame?: { w: number; h: number; x: number; y: number; tweakY: boolean; tweakX: boolean };
	imgURL: string;
	density: number;
	minspace?: number;
	colourSetName?: string;
	//Entries come from ImagePixelDataGrid ({x,y}) or HomeParticleJson.toPixelStyleData
	//(adds radius/rgba/alpha/col/row), so everything beyond x/y is optional:
	pixelData?: Array<{
		x: number;
		y: number;
		col?: number;
		row?: number;
		rgba?: any;
		radius?: number;
		alpha?: number;
		gray?: number;
	}>;
	rawGrid?: ImagePixelDataGrid;
}

export default {
	whaleStart: 46,
	whaleEnd: 107,

	dataSet: {
		wavemesh: {
			ref: 'wavemesh',
			size: { w: 479 * 2.2, h: 280 * 3 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/wavemesh.png',
			density: 0.0005
		},

		halftone: {
			ref: 'halftone',
			size: { w: 479 * 2.2, h: 280 * 3 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/halftone.png',
			density: 0.002
		},

		halftone2: {
			ref: 'halftone2',
			size: { w: 479 * 2.2, h: 280 * 3 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/halftone2.png',
			density: 0.002
		},

		ttballon: {
			ref: 'ttballon',
			size: { w: 479 * 2.2, h: 280 * 3 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tt-balloon.png',
			density: 0.016,
			colourSetName: 'tt'
		},

		mess: {
			ref: 'mess',
			size: { w: 479 * 1, h: 280 * 1 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/mess.png',
			density: 0.018
		},

		hand: {
			ref: 'hand',
			size: { w: 479 * 1, h: 280 * 1 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/hand.png',
			density: 0.018
		},

		pattern: {
			ref: 'pattern',
			size: { w: 479 * 1, h: 280 * 1 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/pattern.png',
			density: 0.018
		},

		pattern2: {
			ref: 'pattern2',
			size: { w: 479 * 1, h: 280 * 1 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/pattern2.png',
			density: 0.018
		},

		pattern3: {
			ref: 'pattern3',
			size: { w: 479 * 1, h: 280 * 1 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/pattern3.png',
			density: 0.018
		},

		pattern4: {
			ref: 'pattern4',
			size: { w: 479 * 1, h: 280 * 1 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/pattern4.png',
			density: 0.018
		},

		eye: {
			ref: 'eye',
			size: { w: 479 * 1, h: 280 * 1 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/eye.png',
			density: 0.018
		},

		hand2: {
			ref: 'hand2',
			size: { w: 479 * 1, h: 280 * 1 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/hand2.png',
			density: 0.018
		},

		hand3: {
			ref: 'hand3',
			size: { w: 479 * 1, h: 280 * 1 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/hand3.png',
			density: 0.018
		},

		m: {
			ref: 'm',
			size: { w: 479 * 2, h: 280 * 2 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/m.png',
			density: 0.018
		},

		one: {
			ref: 'one',
			size: { w: 479 * 1, h: 280 * 1 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/1.png',
			density: 0.018
		},

		two: {
			ref: 'two',
			size: { w: 479 * 1, h: 280 * 1 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/2.png',
			density: 0.018
		},

		tv: {
			ref: 'tv',
			size: { w: 337 * 3, h: 337 * 3 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv.png',
			density: 0.01
		},

		tvblack: {
			ref: 'tvblack',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tvblack.png',
			density: 0.01
		},

		tvblack2: {
			ref: 'tvblack2',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tvblack2.png',
			density: 0.01
		},

		tvblack3: {
			ref: 'tvblack3',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tvblack3.png',
			density: 0.01
		},

		tvblack4: {
			ref: 'tvblack4',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tvblack4.png',
			density: 0.01
		},

		tvblack5: {
			ref: 'tvblack5',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tvblack5.png',
			density: 0.01
		},

		tvblack6: {
			ref: 'tvblack6',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tvblack6.png',
			density: 0.01
		},

		tvblack7: {
			ref: 'tvblack7',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tvblack7.png',
			density: 0.01
		},

		tvblack8: {
			ref: 'tvblack8',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tvblack8.png',
			density: 0.01
		},

		tvblack9: {
			ref: 'tvblack9',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tvblack9.png',
			density: 0.01
		},

		tvblack10: {
			ref: 'tvblack10',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tvblack10.png',
			density: 0.01
		},

		tv2: {
			ref: 'tv2',
			size: { w: 337 * 3, h: 337 * 3 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv2.png',
			density: 0.019
		},

		tv3: {
			ref: 'tv3',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv3.png',
			density: 0.01
		},

		tv3d: {
			ref: 'tv3d',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv3-d.png',
			density: 0.01
		},

		tvm: {
			ref: 'tvm',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv-m.png',
			density: 0.01
		},

		tvmj: {
			ref: 'tvmj',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv-mj.png',
			density: 0.013
		},

		tvmcheck: {
			ref: 'tvmcheck',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv-check.png',
			density: 0.013
		},

		tvcreatures: {
			ref: 'tvcreatures',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv-creatures.png',
			density: 0.013
		},

		tvicons: {
			ref: 'tvicons',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv-icons.png',
			density: 0.013
		},

		tvholes: {
			ref: 'tvholes',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv-holes.png',
			density: 0.013
		},

		tv4: {
			ref: 'tv4',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv4.png',
			density: 0.013
		},

		tv5: {
			ref: 'tv5',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv5.png',
			density: 0.013
		},
		tv6: {
			ref: 'tv6',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv6.png',
			density: 0.013
		},

		tv7: {
			ref: 'tv7',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv7.png',
			density: 0.013
		},
		tv8: {
			ref: 'tv8',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv8.png',
			density: 0.013
		},
		tv9: {
			ref: 'tv9',
			size: { w: 821, h: 697 },
			position: { x: 0.0, y: 0.8 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tv9.png',
			density: 0.013
		},

		moth0: {
			ref: 'moth0',
			size: { w: 600, h: 600 },
			position: { x: 0.0, y: 0.29 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/moth_00.png',
			density: 0.019
		},

		moth1: {
			ref: 'moth1',
			size: { w: 600, h: 600 },
			position: { x: 0.0, y: 0.29 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/moth_01.png',
			density: 0.019
		},

		moth2: {
			ref: 'moth2',
			size: { w: 600, h: 600 },
			position: { x: 0.0, y: 0.29 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/moth_02.png',
			density: 0.019
		},

		moth3: {
			ref: 'moth3',
			size: { w: 600, h: 600 },
			position: { x: 0.0, y: 0.29 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/moth_03.png',
			density: 0.019
		},

		moth4: {
			ref: 'moth4',
			size: { w: 600, h: 600 },
			position: { x: 0.0, y: 0.29 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/moth_04.png',
			density: 0.019
		},

		moth5: {
			ref: 'moth5',
			size: { w: 600, h: 600 },
			position: { x: 0.0, y: 0.29 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/moth_05.png',
			density: 0.019
		},

		moth6: {
			ref: 'moth6',
			size: { w: 600, h: 600 },
			position: { x: 0.0, y: 0.29 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/moth_06.png',
			density: 0.019
		},

		moth7: {
			ref: 'moth7',
			size: { w: 600, h: 600 },
			position: { x: 0.0, y: 0.29 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/moth_07.png',
			density: 0.019
		},

		moth8: {
			ref: 'moth8',
			size: { w: 600, h: 600 },
			position: { x: 0.0, y: 0.29 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/moth_08.png',
			density: 0.019
		},

		moth9: {
			ref: 'moth9',
			size: { w: 600, h: 600 },
			position: { x: 0.0, y: 0.29 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/moth_09.png',
			density: 0.019
		},

		m4g: {
			ref: 'm4g',
			size: { w: 800, h: 600 },
			position: { x: 0.0, y: 0.29 },
			frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/m4g.png',
			density: 0.01,
			colourSetName: 'm4g'
		},

		seven: {
			ref: 'seven',
			size: { w: 350, h: 469 },
			position: { x: 0.15, y: 0.24 },
			frame: { w: 480, h: 360, x: 0.2, y: 0.44, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/seven.jpg',
			density: 0.01
		},

		phoneFlat: {
			ref: 'phoneFlat',
			size: { w: 300, h: 480 },
			position: { x: 0.15, y: 0.24 },
			frame: { w: 480, h: 360, x: 0.2, y: 0.44, tweakY: true, tweakX: false },
			imgURL: '/img/home/pixel/phone-flat.jpg',
			density: 0.02
		},

		icon: {
			ref: 'icon',
			size: { w: 400 * 2, h: 320 * 2 },
			position: { x: 0.15, y: 0.18 },
			frame: { w: 480, h: 360, x: 0.2, y: 0.2, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/icon.jpg',
			density: 0.01
		},

		robot: {
			ref: 'robot',
			size: { w: 400, h: 340 },
			position: { x: 0.15, y: 0.24 },
			frame: { w: 480, h: 360, x: 0.2, y: 0.44, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/robot.jpg',
			density: 0.027
		},

		vr: {
			ref: 'vr',
			size: { w: 400, h: 300 },
			position: { x: 0.15, y: 0.24 },
			frame: { w: 480, h: 360, x: 0.2, y: 0.44, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/vr.jpg',
			density: 0.027
		},

		arcadeMachine: {
			ref: 'arcadeMachine',
			size: { w: 380 * 2, h: 480 * 2 },
			position: { x: 0.15, y: 0.1 },
			frame: { w: 480, h: 360, x: 0.2, y: 0.44, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/arcadeMachine.jpg',
			density: 0.027
		},

		tree: {
			ref: 'tree',
			size: { w: 380 * 2, h: 440 * 2 },
			position: { x: 0.15, y: 0.24 },
			frame: { w: 480, h: 360, x: 0.2, y: 0.44, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tree.jpg',
			density: 0.02
		},

		house: {
			ref: 'house',
			size: { w: 600, h: 426 },
			position: { x: 0.165, y: 0.13 },
			frame: { w: 350, h: 400, x: 0.2, y: 0.4, tweakY: true, tweakX: false },
			imgURL: '/img/home/pixel/house.jpg',
			density: 0.02
		},

		leg: {
			ref: 'leg',
			size: { w: 300 * 2, h: 464 * 2 },
			position: { x: 0.165, y: 0.13 },
			frame: { w: 350, h: 400, x: 0.2, y: 0.4, tweakY: true, tweakX: false },
			imgURL: '/img/home/pixel/leg.png',
			density: 0.0033,
			minspace: 3
		},

		swirl: {
			ref: 'swirl',
			size: { w: 300, h: 464 },
			position: { x: 0.165, y: 0.13 },
			frame: { w: 350, h: 400, x: 0.2, y: 0.4, tweakY: true, tweakX: false },
			imgURL: '/img/home/pixel/swirl.jpg',
			density: 0.01
		},

		drawing: {
			ref: 'drawing',
			size: { w: 600, h: 600 },
			position: { x: 0.165, y: 0.13 },
			frame: { w: 350, h: 400, x: 0.2, y: 0.4, tweakY: true, tweakX: false },
			imgURL: '/img/home/pixel/drawing.jpg',
			density: 0.01
		},

		head: {
			ref: 'head',
			size: { w: 660, h: 400 },
			position: { x: 0.15, y: 0.24 },
			frame: { w: 480, h: 360, x: 0.2, y: 0.44, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/tree.jpg',
			density: 0.02
		},

		man: {
			ref: 'man',
			size: { w: 550, h: 550 },
			position: { x: 0.165, y: 0.13 },
			frame: { w: 550, h: 450, x: 0.2, y: 0.4, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/abstract.jpg',
			density: 0.02
		},

		circle: {
			ref: 'circle',
			size: { w: 470, h: 300 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/controller.jpg',
			density: 0.02
		},

		phone: {
			ref: 'phone',
			size: { w: 550, h: 380 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/phone.jpg',
			density: 0.02
		},

		island: {
			ref: 'island',
			size: { w: 240 * 2, h: 300 * 2 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/island.jpg',
			density: 0.02
		},

		island2: {
			ref: 'island2',
			size: { w: 240 * 4, h: 300 * 8 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/island.jpg',
			density: 0.02
		},

		lineVR: {
			ref: 'lineVR',
			size: { w: 600, h: 369 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/line-vr.jpg',
			density: 0.015,
			minspace: 1
		},

		neonMoth1: {
			ref: 'neonMoth1',
			size: { w: 600, h: 369 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/neon-moth-1.png',
			density: 0.01,
			minspace: 1
		},

		neonMoth2: {
			ref: 'neonMoth2',
			size: { w: 600, h: 369 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/neon-moth-2.png',
			density: 0.01,
			minspace: 1
		},

		neonMoth3: {
			ref: 'neonMoth3',
			size: { w: 600, h: 369 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/neon-moth-3.png',
			density: 0.018,
			minspace: 1
		},

		neonMoth4: {
			ref: 'neonMoth4',
			size: { w: 600, h: 369 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/neon-moth-4.png',
			density: 0.018,
			minspace: 1
		},

		mesh: {
			ref: 'mesh',
			size: { w: 550, h: 282 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/mesh.jpg',
			density: 0.002,
			minspace: 10
		},

		worldWireframe: {
			ref: 'worldWireframe',
			size: { w: 360 * 3, h: 400 * 3 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/world.png',
			density: 0.001,
			minspace: 25
		},

		differ: {
			ref: 'differ',
			size: { w: 275, h: 275 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/differ.jpg',
			density: 0.025,
			colourSetName: 'differ'
		},

		differ2: {
			ref: 'differ2',
			size: { w: 275 * 3.8, h: 275 * 7 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/differ.jpg',
			density: 0.015
		},

		charts: {
			ref: 'charts',
			size: { w: 550, h: 350 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/charts.jpg',
			density: 0.015
		},

		ring: {
			ref: 'ring',
			size: { w: 600, h: 600 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/ring.jpg',
			density: 0.022
		},

		longChart: {
			ref: 'longChart',
			size: { w: 290, h: 400 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/long-chart.jpg',
			density: 0.028
		},

		ps4: {
			ref: 'ps4',
			size: { w: 600, h: 281 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/ps4.jpg',
			density: 0.015
		},

		blob1: {
			ref: 'blob1',
			size: { w: 300, h: 300 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/blob1.png',
			density: 0.02
		},

		blob2: {
			ref: 'blob2',
			size: { w: 300, h: 300 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/blob2.png',
			density: 0.013
		},

		blob3: {
			ref: 'blob3',
			size: { w: 300, h: 300 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/blob3.png',
			density: 0.013
		},

		differ3DBall: {
			ref: 'differ3DBall',
			size: { w: 300, h: 300 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/differ-3d-ball.jpg',
			density: 0.016
		},

		differCircle: {
			ref: 'differCircle',
			size: { w: 300, h: 300 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/differ-circle.jpg',
			density: 0.012
		},

		cube: {
			ref: 'cube',
			size: { w: 300, h: 300 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/cube.jpg',
			density: 0.02
		},

		arrow: {
			ref: 'arrow',
			size: { w: 600, h: 250 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/arrow.jpg',
			density: 0.01,
			minspace: 4
		},

		thing: {
			ref: 'thing',
			size: { w: 336, h: 300 },
			position: { x: 0.165, y: 0.29 },
			frame: { w: 400, h: 400, x: 0.2, y: 0.445, tweakY: false, tweakX: false },
			imgURL: '/img/home/pixel/thing.png',
			density: 0.016
		}
	} as { [ref: string]: PixelDataItem },

	createWhaleConfig() {
		for (var i = this.whaleStart; i <= this.whaleEnd; i++) {
			this.dataSet['whale' + i] = {
				ref: 'whale' + i,
				size: { w: 300 * 1.8, h: 300 * 1.8 },
				position: { x: 0.0, y: 0.8 },
				frame: { w: 278 * 0.5, h: 292 * 0.5, x: 0.0, y: 0.445, tweakY: false, tweakX: false },
				imgURL: '/img/home/pixel/whale/Whale' + i + '.png',
				density: 0.0115
			};
		}
	},

	getList() {
		var jsonItems = HomeParticleJson.getItems();
		var lady = jsonItems[0];

		for (var i = this.whaleStart; i <= this.whaleEnd; i++) {
		}


		return [
			lady




		];

		return [
			this.dataSet.tv3,
			this.dataSet.tvblack,
			lady,
			this.dataSet.tvblack2,
			this.dataSet.tvblack3,
			this.dataSet.tvblack4,
			this.dataSet.tvblack5,
			this.dataSet.tvblack6,
			this.dataSet.tvblack7,
			this.dataSet.tvblack8,
			this.dataSet.tvblack9,
			this.dataSet.tvblack10,
			this.dataSet.tvblack10,
			this.dataSet.tvblack10,
			this.dataSet.tvblack10
		];

		return [
			this.dataSet.m4g,
			this.dataSet.m4g,
			this.dataSet.m4g,
			this.dataSet.m4g,
			this.dataSet.m4g,
			this.dataSet.m4g,
			this.dataSet.m4g,
			this.dataSet.leg,
			this.dataSet.m4g,
			this.dataSet.charts,
			this.dataSet.leg,
			this.dataSet.charts,
			this.dataSet.differ3DBall,
			this.dataSet.leg,
			this.dataSet.differ3DBall,
			this.dataSet.charts,
			this.dataSet.ps4,
			this.dataSet.longChart,
			this.dataSet.ring,
			this.dataSet.differ,
			this.dataSet.arrow,
			this.dataSet.differCircle,

			this.dataSet.cube,
			this.dataSet.thing,
			this.dataSet.swirl,
			this.dataSet.lineVR,

			this.dataSet.worldWireframe,
			this.dataSet.island,
			this.dataSet.phone,
			this.dataSet.icon,

			this.dataSet.arcadeMachine,
			this.dataSet.vr,
			this.dataSet.tree,
			this.dataSet.house,

			this.dataSet.circle,
			this.dataSet.drawing
		];
	},

	loadPixels(item) {
		if (!item.imgURL) {
			return;
		}

		let loader = new ImagePixelDataGrid(
			item.density,
			(pixelData) => {
				this.dataSet[item.ref].pixelData = pixelData;
				this.dataSet[item.ref].rawGrid = loader;
			},
			item.minspace
		);

		loader.byURL(item.imgURL, item.colourSetName);
	}
};
